import { Box } from "@mui/material";
import { useCallback, useEffect, useRef } from "react";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import FaultRecognition, { FaultRecognitionProps } from "./FaultRecognition";
import { FaultSymptoms, SymptomSelectBoxProps } from "./FaultSymptoms";

type FaultDetailsStepProps = SymptomSelectBoxProps & FaultRecognitionProps;
export const FaultDetailsStep = ({onRecognitionDateTimeChange ,...symptomProps}: FaultDetailsStepProps) => {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const stepRef = useRef<HTMLDivElement>(null);

  const handleReCaptchaVerify = useCallback(async () => {
    if (!executeRecaptcha) {
      console.warn("Execute recaptcha not yet available");
      return;
    }

    await executeRecaptcha("submit_fault_report");
  }, [executeRecaptcha]);

  useEffect(() => {
    handleReCaptchaVerify();
  }, [handleReCaptchaVerify]);

  // Scroll to top when this step mounts
  useEffect(() => {
    stepRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);


  return (
    <Box ref={stepRef} display="flex" flexDirection="column" alignItems="center" gap={{ xs: '24px', sm: '60px' }}>
      <FaultSymptoms {...symptomProps} />
      <FaultRecognition onRecognitionDateTimeChange={onRecognitionDateTimeChange}/>
    </Box>
  );
};

export default FaultDetailsStep;
